import { Box, Grid, Paper, Skeleton } from "@mui/material";

export const DocumentFormSkeleton = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Skeleton variant="text" width="40%" height={36} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={12}
              sx={{ mt: 1 }}
            />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rectangular" height={40} />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rectangular" height={40} />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Skeleton variant="rectangular" height={40} />
              </Grid>

              <Grid item xs={12} sx={{ mt: 1 }}>
                <Skeleton variant="rectangular" height={200} />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Skeleton variant="rectangular" height={48} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Skeleton variant="rectangular" height={48} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
